import ApiService from "../../services/api";
import gridClientBase from "../../components/gridClientComponentBase";
import moment from "moment-timezone";
import cellDeleteCommand from "../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import { mapGetters } from "vuex";

export default {
	extends: gridClientBase,
	data: () => {
		return {
			isDetailInEditMode: false,

			userDivisions: [],
			groupsData: [],
			groupsSelected: [],

			id: 0,
			name: "",
			number_plate: "",
			car_sharing: false,
			purpose: "",
			fringe_benefit: false,
			matriculation_date: "",
			expulsion_date: "",
			declared_co2_emission: null,
			average_consumption: 0,
			gross_vehicle_mass: 0,
			power_kw: "kW",
			displacement: 0,
			vehicle_name: "",
			tank_capacity: 0,
			driver_fiscal_code: "",
			utilization_area: "",
			battery_capacity: "",
			km_covered_recharge: "",
			fuel_level_not_available: false,

			brand: { key: 0, value: "" },
			ownership_type: { key: 0, value: "" },
			groups: [{ key: 0, value: "" }],
			fuel_type: { key: 0, value: "" },
			secondary_fuel_type: { key: 0, value: "" },
			category: { key: 0, value: "" },
			division: { key: 0, value: "" },
			driving_license_type: { key: 0, value: "" },
			ownership_supplier: { key: 0, value: "" },

			code: "",
			matriculation: "",
			//average_ownership_consumption: "",
			savePendingRequest: null,
			saveVechilesDriversAssociationRequest: null,

			drivers: [],
			itemTemplate: "<div style='height: 50px'>#= surname # #= name # <br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",
			valueTemplate: "#= surname # #= name #",

			//table filters
			driverNameFilters: [],
			driverNameFilterSelected: [],
			driverSurnameFilters: [],
			driverSurnameFilterSelected: [],
			driverCFFilters: [],
			driverCFFilterSelected: [],

			datePickerFooter: "Oggi - #=kendo.toString(data, 'dd MMMM yyyy') #",

			hasDivisions: false
		};
	},

	created() {
		var self = this;

		if (this.settings && this.settings.hasDivisions) this.hasDivisions = true;		
		this.getGroups();
		if (this.hasDivisions) this.getUserDivision();
		this.getData();
		this.getAllDrivers();

		var newItem = {
			id: 0,
			name: "",
			surname: "",
			email: "",
			fiscal_code: "",
			start_date: null,
			end_date: null,
			driver_id: 0,
			vehicle_id: self.$route.params.id
		};
		this.defaultAddRow = newItem;
		this.sort = [{ field: "start_date", dir: "desc" }];

		this.take = 1000000;
	},

	methods: {
		expulsionDateChange(item) {
			if (item.sender.value()) {
				var newExpulsionDate = moment(item.sender.value()).startOf("days");
				this.expulsion_date = newExpulsionDate.format();
			} else {
				this.expulsion_date = null;
			}
		},
		onDriverChange(e, rowId) {
			var newValue = e.sender.value();

			var row = this.items.find(function(item) {
				return item.id === rowId;
			});

			var newDriver = this.drivers.find(item => {
				return item.id == newValue;
			});

			if (row) {
				row.name = newDriver.name;
				row.surname = newDriver.surname;
				row.email = newDriver.email;
				row.fiscal_code = newDriver.fiscal_code;
				// row.start_date = "";
				// row.end_date = "";
				row.driver_id = newDriver.id;
			}

			this.itemChange({
				dataItem: row
			});
		},
		getAllDrivers() {
			var self = this;
			ApiService.getDriversData({ page: 0, pageSize: 1000000 }).then(res => {
				self.drivers = res.items.map(function(driver) {
					return {
						id: driver.id,
						name: driver.name ? driver.name.toLowerCase() : "",
						surname: driver.surname ? driver.surname.toLowerCase() : "",
						name_surname_fiscalcode: `${driver.name} ${driver.surname} ${driver.fiscal_code}`,
						fiscal_code: driver.fiscal_code
					};
				});

				self.getDrivers();

				self.drivers = self._.sortBy(self.drivers, ["surname", "name", "fiscal_code"]);
				for (var i = 0; i < self.drivers.length; i++) {
					var driver = self.drivers[i];

					if (driver.name) {
						var alreadyExist =
							self.driverNameFilters.findIndex(item => {
								return item.id == `${driver.surname.toLowerCase()} ${driver.name.toLowerCase()}`;
							}) >= 0;
						if (!alreadyExist) {
							self.driverNameFilters.push({
								id: `${driver.surname.toLowerCase()} ${driver.name.toLowerCase()}`,
								value: `${driver.surname.toLowerCase()} ${driver.name.toLowerCase()}`
							});
						}
					}

					// if (driver.surname) {
					// 	var alreadyExist =
					// 		self.driverSurnameFilters.findIndex(item => {
					// 			return item.id == driver.surname.toLowerCase();
					// 		}) >= 0;
					// 	if (!alreadyExist) {
					// 		self.driverSurnameFilters.push({
					// 			id: driver.surname.toLowerCase(),
					// 			value: driver.surname.toLowerCase()
					// 		});
					// 	}
					// }
					if (driver.fiscal_code) {
						var alreadyExist =
							self.driverCFFilters.findIndex(item => {
								return item.id == driver.fiscal_code.toLowerCase();
							}) >= 0;
						if (!alreadyExist) {
							self.driverCFFilters.push({
								id: driver.fiscal_code.toLowerCase(),
								value: driver.fiscal_code.toLowerCase()
							});
						}
					}
				}

				self.driverCFFilters = self._.sortBy(self.driverCFFilters, ["id"]);
			});
		},
		getDrivers: function() {
			var self = this;
			var idVehicle = this.$route.params.id;

			ApiService.getDriversByVehicleId(idVehicle).then(res => {
				if (self._.isNull(res) === false && self._.isUndefined(res) === false && self._.isArray(res) && res.length > 0)
					self.items = res.map(function(item) {
						return {
							id: item.id,
							name: `${item.surname.toLowerCase()} ${item.name.toLowerCase()}`,
							//surname: item.surname,
							email: item.email,
							fiscal_code: item.fiscal_code,
							start_date: item.start_date,
							end_date: item.end_date,
							driver_id: item.driver_id,
							vehicle_id: item.vehicle_id
						};
					});
			});
		},
		getGroups: function() {
			var self = this;
			ApiService.getGroupsData().then(res => {
				self.groupsData = res.map(function(item) {
					return {
						id: item.id,
						description: item.name ? item.name.toLowerCase() : ""
					};
				});

				self.groupsData = self._.sortBy(self.groupsData, ["description"]);
			});
		},
		getUserDivision() {
			var self = this;
			ApiService.getUserDivision()
				.then(res => {
					self.userDivisions = self._.sortBy(res, function (item) {
						return item.value ? item.value.toLowerCase() : "";
					});
				})
				.catch(err => {});
		},
		getData() {
			var self = this;
			var idVehicle = this.$route.params.id;
			ApiService.getVehicleDetail(idVehicle)
				.then(res => {
					if (self._.isNull(res.data) === false) {
						var data = res;

						self.id = data.id;
						self.name = `${data.driver_surname || ""} ${data.driver_name || ""}`;
						self.number_plate = data.number_plate;
						self.car_sharing = data.car_sharing;
						self.purpose = data.purpose;
						self.fringe_benefit = data.fringe_benefit;
						self.matriculation_date = data.matriculation_date;
						self.expulsion_date = self.getUtcDate(data.expulsion_date);
						self.declared_co2_emission = data.declared_co2_emission;
						self.average_consumption = data.average_consumption;
						self.gross_vehicle_mass = data.gross_vehicle_mass;
						self.power_kw = data.power_kw;
						self.displacement = data.displacement;
						self.vehicle_name = data.name;
						self.tank_capacity = data.tank_capacity;
						self.driver_fiscal_code = data.driver_fiscal_code;
						self.battery_capacity = data.battery_capacity;
						self.km_covered_recharge = data.km_covered_recharge,
						self.fuel_level_not_available = data.fuel_level_not_available,
						self.utilization_area = data.utilization_area ? data.utilization_area : "";
						self.brand = data.brand || { key: 0, value: "" };
						self.ownership_type = data.ownership_type || { key: 0, value: "" };
						self.groups = data.groups || [{ key: 0, value: "" }];
						self.fuel_type = data.fuel_type || { key: 0, value: "" };
						self.secondary_fuel_type = data.secondary_fuel_type || { key: 0, value: "" }
						self.category = data.category || { key: 0, value: "" };
						self.division = data.division || { key: 0, value: "" };
						self.driving_license_type = data.driving_license_type || { key: 0, value: "" };
						self.ownership_supplier = data.ownership_supplier || { key: 0, value: "" };

						self.code = data.code;
						self.matriculation = data.matriculation;
						//self.average_ownership_consumption = data.average_ownership_consumption;

						self.groupsSelected = self._.sortBy(data.groups, function(it) {
							return it.value ? it.value.toLowerCase() : "";
						}).map(function(e) {
							return e.key;
						});
					}
				})
				.catch(err => {
					//redirect to list
					self.$router.push({
						name: "VEHICLES_LIST_BOX"
					});
				});
		},
		getUtcDate(date) {
			if (date) {
				return moment
					.utc(date)
					.tz("Europe/Rome")
					.format();
			}

			return null;
		},
		groupsToString(groups) {
			if (this._.isNull(groups) === false && this._.isUndefined(groups) === false && this._.isArray(groups) && groups.length > 0) {
				var str = "";
				groups = this._.sortBy(groups, function(it) {
					return it.value ? it.value.toLowerCase() : "";
				});
				groups.forEach(element => {
					str += element.value + ", ";
				});

				str = str.replace(/, $/, "");
				return str;
			}

			return "";
		},
		switchEditMode() {
			this.isInEditMode = !this.isInEditMode;

			if (!this.isInEditMode) {
				this.clearWorkingData();
				this.getDrivers();
			}

			this.saveVechilesDriversAssociationRequest = null;
		},
		saveData() {
			var self = this;
			if (this.savePendingRequest == null) {
				this.savePendingRequest = ApiService.saveVehicleDetail(
					this.id,
					this.car_sharing,
					this.division.key,
					this.purpose,
					this.fringe_benefit,
					this.groupsSelected,
					this.utilization_area,
					this.expulsion_date
				)
					.then(res => {
						self.isDetailInEditMode = false;
						self.getData();
					})
					.catch(err => {})
					.finally(_ => {
						self.savePendingRequest = null;
					});
			}
		},
		saveDriversData() {
			var self = this;

			var createdItemsNormilized = [];
			for (let i = 0; i < this.createdItems.length; i++) {
				let item = this._.clone(this.createdItems[i]);

				if (item.start_date) {
					item.start_date = this.dateStringToMomentFormat(item.start_date);
				}

				if (item.end_date) {
					item.end_date = this.dateStringToMomentFormat(item.end_date);
				} else {
					item.end_date = null;
				}
				createdItemsNormilized.push(item);
			}

			var updatedItemsNormilized = [];
			for (let i = 0; i < this.updatedItems.length; i++) {
				let item = this._.clone(this.updatedItems[i]);

				if (item.start_date) {
					item.start_date = this.dateStringToMomentFormat(item.start_date);
				}

				if (item.end_date) {
					item.end_date = this.dateStringToMomentFormat(item.end_date);
				} else {
					item.end_date = null;
				}
				updatedItemsNormilized.push(item);
			}

			var deletedItemsNormilized = [];
			for (let i = 0; i < this.deletedItems.length; i++) {
				let item = this._.clone(this.deletedItems[i]);

				if (item.start_date) {
					item.start_date = this.dateStringToMomentFormat(item.start_date);
				}

				if (item.end_date) {
					item.end_date = this.dateStringToMomentFormat(item.end_date);
				} else {
					item.end_date = null;
				}
				deletedItemsNormilized.push(item);
			}

			this.saveVechilesDriversAssociationRequest = ApiService.saveVehiclesDriversAssociation(createdItemsNormilized, updatedItemsNormilized, deletedItemsNormilized)
				.then(res => {
					self.clearWorkingData();
					self.getDrivers();

					self.isDetailInEditMode = false;
					self.getData();
				})
				.catch(err => {})
				.finally(_ => {
					self.saveVechilesDriversAssociationRequest = null;
				});
		},
		dateStringToMomentFormat(dateString) {
			if (dateString.indexOf("/") >= 0) {
				return moment(dateString, "DD/MM/YYYY").format();
			}

			return moment(dateString).format();
		},
		switchDetailEditMode: function() {
			this.isDetailInEditMode = !this.isDetailInEditMode;

			if (!this.isDetailInEditMode) {
				this.getData();
			}

			this.savePendingRequest = null;
		},

		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},
		//unite of Measure
		getPropertyDescription(propertyValue, uniteOfMeasure, type) {
			uniteOfMeasure = uniteOfMeasure ? uniteOfMeasure : '';
			return `${propertyValue ? kendo.toString(propertyValue, `${type && type == "int" ? 'n0' : 'n2'}`) : ""} ${propertyValue && uniteOfMeasure ? "(" + uniteOfMeasure + ")" : ""}`;
		}
	},

	computed: {
		...mapGetters(["settings"]),
		matriculationDateFormat() {
			if (this.matriculation_date) {
				this.matriculation_date = moment
					.utc(this.matriculation_date)
					.tz("Europe/Rome")
					.format();
			}
			return this.$options.filters.dateToString(this.matriculation_date);
		},
		expulsionDateFormat() {
			return this.$options.filters.dateToString(this.expulsion_date);
		},
		expulsionDateFormatCalendar() {
			if (this.expulsion_date) {
				return moment(this.expulsion_date).format("DD MMMM YYYY");
			}

			return "";
		},
		groupsString() {
			return this.groupsToString(this.groups);
		},
		columns: function() {
			return [
				{
					field: "name",
					title: "cognome e nome",
					headerCell: "myDriverNameHeaderTemplate",
					cell: "nameCellTemplate",
					format: "",
					filterable: true
				},
				// {
				// 	field: "surname",
				// 	title: "cognome",
				// 	headerCell: "myDriverSurnameHeaderTemplate",
				// 	format: "",
				// 	filterable: true
				// },
				// {
				// 	field: "email",
				// 	title: "email",
				// 	width: "200px",
				// 	headerCell: "myHeaderTemplate"
				// },
				{
					field: "fiscal_code",
					title: "Codice Fiscale",
					width: "200px",
					headerCell: "myDriverCFHeaderTemplate",
					format: "",
					filterable: true
				},
				{
					field: "start_date",
					title: "Data Inizio",
					format: "date",
					headerCell: "myDateHeaderTemplate",
					cell: "myCellTemplate",
					filterable: true
				},
				{
					field: "end_date",
					title: "Data Fine",
					format: "date",
					headerCell: "myDateHeaderTemplate",
					cell: "myCellTemplateNotRequired",
					filterable: true
				},
				{
					cell: cellDeleteCommand,
					width: "45px",
					sortable: false,
					headerCell: "myHeaderTemplate"
				}
			];
		},

		
	}
};
